/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type HpRespInformationalContent_viewer$ref = any;
export type HpRespInformationalContent_viewer = {
    readonly informationalContent?: {
        readonly visible: boolean | null;
        readonly title: string | null;
        readonly benefits: ReadonlyArray<string | null> | null;
        readonly ctaText: string | null;
        readonly ctaUrl: string | null;
        readonly ctaTitle: string | null;
    } | null;
    readonly " $refType": HpRespInformationalContent_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "HpRespInformationalContent_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isTrade",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "Condition",
            "passingValue": false,
            "condition": "isTrade",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "informationalContent",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "InformationalContentType",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "visible",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "title",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "benefits",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "ctaText",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "ctaUrl",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "ctaTitle",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '8a85bdd27c98936604ccb631d4649b5a';
export default node;
